<template>
  <div>
    <v-chip v-if="showChip" :color="chipColour" small>
      <span class="font-weight-bold">
        {{ chipText }}
      </span>
    </v-chip>
  </div>
</template>

<script>
import { ExtractionTemplateItemStyle } from '@/enums';
export default {
  name: 'ExtractionTemplateModifiedStatusChip',
  props: {
    itemStyle: {
      type: String,
      default: ExtractionTemplateItemStyle.DEFAULT,
      validator: (val) =>
        Object.values(ExtractionTemplateItemStyle).includes(val),
    },
  },
  computed: {
    showChip() {
      return this.itemStyle != ExtractionTemplateItemStyle.DEFAULT;
    },
    chipColour() {
      switch (this.itemStyle) {
        case ExtractionTemplateItemStyle.NEW:
          return 'primary';
        case ExtractionTemplateItemStyle.MODIFIED:
          return 'success';
        case ExtractionTemplateItemStyle.DELETED:
          return 'error';
        default:
          return null;
      }
    },
    chipText() {
      switch (this.itemStyle) {
        case ExtractionTemplateItemStyle.NEW:
          return 'Added';
        case ExtractionTemplateItemStyle.MODIFIED:
          return 'Modified';
        case ExtractionTemplateItemStyle.DELETED:
          return 'Removed';
        default:
          return null;
      }
    },
  },
};
</script>
